/**
 * ISO-3166 alpha-2 countries, as Easyship takes them.
 *
 * The same list the API validates against. Patient addresses used a free-text
 * country box for years ('USA', 'United States', 'us'), and Easyship takes the
 * two-letter code and nothing else — so the forms pick from this list instead.
 */
export interface Country {
  alpha2: string;
  name: string;
}

export const COUNTRIES: ReadonlyArray<Country> = [
  { alpha2: 'AD', name: 'Andorra' },
  { alpha2: 'AE', name: 'United Arab Emirates' },
  { alpha2: 'AF', name: 'Afghanistan' },
  { alpha2: 'AG', name: 'Antigua and Barbuda' },
  { alpha2: 'AI', name: 'Anguilla' },
  { alpha2: 'AL', name: 'Albania' },
  { alpha2: 'AM', name: 'Armenia' },
  { alpha2: 'AO', name: 'Angola' },
  { alpha2: 'AQ', name: 'Antarctica' },
  { alpha2: 'AR', name: 'Argentina' },
  { alpha2: 'AS', name: 'American Samoa' },
  { alpha2: 'AT', name: 'Austria' },
  { alpha2: 'AU', name: 'Australia' },
  { alpha2: 'AW', name: 'Aruba' },
  { alpha2: 'AX', name: 'Åland Islands' },
  { alpha2: 'AZ', name: 'Azerbaijan' },
  { alpha2: 'BA', name: 'Bosnia and Herzegovina' },
  { alpha2: 'BB', name: 'Barbados' },
  { alpha2: 'BD', name: 'Bangladesh' },
  { alpha2: 'BE', name: 'Belgium' },
  { alpha2: 'BF', name: 'Burkina Faso' },
  { alpha2: 'BG', name: 'Bulgaria' },
  { alpha2: 'BH', name: 'Bahrain' },
  { alpha2: 'BI', name: 'Burundi' },
  { alpha2: 'BJ', name: 'Benin' },
  { alpha2: 'BL', name: 'Saint Barthélemy' },
  { alpha2: 'BM', name: 'Bermuda' },
  { alpha2: 'BN', name: 'Brunei Darussalam' },
  { alpha2: 'BO', name: 'Bolivia' },
  { alpha2: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
  { alpha2: 'BR', name: 'Brazil' },
  { alpha2: 'BS', name: 'Bahamas' },
  { alpha2: 'BT', name: 'Bhutan' },
  { alpha2: 'BV', name: 'Bouvet Island' },
  { alpha2: 'BW', name: 'Botswana' },
  { alpha2: 'BY', name: 'Belarus' },
  { alpha2: 'BZ', name: 'Belize' },
  { alpha2: 'CA', name: 'Canada' },
  { alpha2: 'CC', name: 'Cocos (Keeling) Islands' },
  { alpha2: 'CD', name: 'Congo, Democratic Republic of the' },
  { alpha2: 'CF', name: 'Central African Republic' },
  { alpha2: 'CG', name: 'Congo' },
  { alpha2: 'CH', name: 'Switzerland' },
  { alpha2: 'CI', name: "Côte d'Ivoire" },
  { alpha2: 'CK', name: 'Cook Islands' },
  { alpha2: 'CL', name: 'Chile' },
  { alpha2: 'CM', name: 'Cameroon' },
  { alpha2: 'CN', name: 'China' },
  { alpha2: 'CO', name: 'Colombia' },
  { alpha2: 'CR', name: 'Costa Rica' },
  { alpha2: 'CU', name: 'Cuba' },
  { alpha2: 'CV', name: 'Cabo Verde' },
  { alpha2: 'CW', name: 'Curaçao' },
  { alpha2: 'CX', name: 'Christmas Island' },
  { alpha2: 'CY', name: 'Cyprus' },
  { alpha2: 'CZ', name: 'Czechia' },
  { alpha2: 'DE', name: 'Germany' },
  { alpha2: 'DJ', name: 'Djibouti' },
  { alpha2: 'DK', name: 'Denmark' },
  { alpha2: 'DM', name: 'Dominica' },
  { alpha2: 'DO', name: 'Dominican Republic' },
  { alpha2: 'DZ', name: 'Algeria' },
  { alpha2: 'EC', name: 'Ecuador' },
  { alpha2: 'EE', name: 'Estonia' },
  { alpha2: 'EG', name: 'Egypt' },
  { alpha2: 'EH', name: 'Western Sahara' },
  { alpha2: 'ER', name: 'Eritrea' },
  { alpha2: 'ES', name: 'Spain' },
  { alpha2: 'ET', name: 'Ethiopia' },
  { alpha2: 'FI', name: 'Finland' },
  { alpha2: 'FJ', name: 'Fiji' },
  { alpha2: 'FK', name: 'Falkland Islands (Malvinas)' },
  { alpha2: 'FM', name: 'Micronesia' },
  { alpha2: 'FO', name: 'Faroe Islands' },
  { alpha2: 'FR', name: 'France' },
  { alpha2: 'GA', name: 'Gabon' },
  { alpha2: 'GB', name: 'United Kingdom' },
  { alpha2: 'GD', name: 'Grenada' },
  { alpha2: 'GE', name: 'Georgia' },
  { alpha2: 'GF', name: 'French Guiana' },
  { alpha2: 'GG', name: 'Guernsey' },
  { alpha2: 'GH', name: 'Ghana' },
  { alpha2: 'GI', name: 'Gibraltar' },
  { alpha2: 'GL', name: 'Greenland' },
  { alpha2: 'GM', name: 'Gambia' },
  { alpha2: 'GN', name: 'Guinea' },
  { alpha2: 'GP', name: 'Guadeloupe' },
  { alpha2: 'GQ', name: 'Equatorial Guinea' },
  { alpha2: 'GR', name: 'Greece' },
  { alpha2: 'GS', name: 'South Georgia and the South Sandwich Islands' },
  { alpha2: 'GT', name: 'Guatemala' },
  { alpha2: 'GU', name: 'Guam' },
  { alpha2: 'GW', name: 'Guinea-Bissau' },
  { alpha2: 'GY', name: 'Guyana' },
  { alpha2: 'HK', name: 'Hong Kong' },
  { alpha2: 'HM', name: 'Heard Island and McDonald Islands' },
  { alpha2: 'HN', name: 'Honduras' },
  { alpha2: 'HR', name: 'Croatia' },
  { alpha2: 'HT', name: 'Haiti' },
  { alpha2: 'HU', name: 'Hungary' },
  { alpha2: 'ID', name: 'Indonesia' },
  { alpha2: 'IE', name: 'Ireland' },
  { alpha2: 'IL', name: 'Israel' },
  { alpha2: 'IM', name: 'Isle of Man' },
  { alpha2: 'IN', name: 'India' },
  { alpha2: 'IO', name: 'British Indian Ocean Territory' },
  { alpha2: 'IQ', name: 'Iraq' },
  { alpha2: 'IR', name: 'Iran' },
  { alpha2: 'IS', name: 'Iceland' },
  { alpha2: 'IT', name: 'Italy' },
  { alpha2: 'JE', name: 'Jersey' },
  { alpha2: 'JM', name: 'Jamaica' },
  { alpha2: 'JO', name: 'Jordan' },
  { alpha2: 'JP', name: 'Japan' },
  { alpha2: 'KE', name: 'Kenya' },
  { alpha2: 'KG', name: 'Kyrgyzstan' },
  { alpha2: 'KH', name: 'Cambodia' },
  { alpha2: 'KI', name: 'Kiribati' },
  { alpha2: 'KM', name: 'Comoros' },
  { alpha2: 'KN', name: 'Saint Kitts and Nevis' },
  { alpha2: 'KP', name: "Korea, Democratic People's Republic of" },
  { alpha2: 'KR', name: 'Korea, Republic of' },
  { alpha2: 'KW', name: 'Kuwait' },
  { alpha2: 'KY', name: 'Cayman Islands' },
  { alpha2: 'KZ', name: 'Kazakhstan' },
  { alpha2: 'LA', name: "Lao People's Democratic Republic" },
  { alpha2: 'LB', name: 'Lebanon' },
  { alpha2: 'LC', name: 'Saint Lucia' },
  { alpha2: 'LI', name: 'Liechtenstein' },
  { alpha2: 'LK', name: 'Sri Lanka' },
  { alpha2: 'LR', name: 'Liberia' },
  { alpha2: 'LS', name: 'Lesotho' },
  { alpha2: 'LT', name: 'Lithuania' },
  { alpha2: 'LU', name: 'Luxembourg' },
  { alpha2: 'LV', name: 'Latvia' },
  { alpha2: 'LY', name: 'Libya' },
  { alpha2: 'MA', name: 'Morocco' },
  { alpha2: 'MC', name: 'Monaco' },
  { alpha2: 'MD', name: 'Moldova' },
  { alpha2: 'ME', name: 'Montenegro' },
  { alpha2: 'MF', name: 'Saint Martin (French part)' },
  { alpha2: 'MG', name: 'Madagascar' },
  { alpha2: 'MH', name: 'Marshall Islands' },
  { alpha2: 'MK', name: 'North Macedonia' },
  { alpha2: 'ML', name: 'Mali' },
  { alpha2: 'MM', name: 'Myanmar' },
  { alpha2: 'MN', name: 'Mongolia' },
  { alpha2: 'MO', name: 'Macao' },
  { alpha2: 'MP', name: 'Northern Mariana Islands' },
  { alpha2: 'MQ', name: 'Martinique' },
  { alpha2: 'MR', name: 'Mauritania' },
  { alpha2: 'MS', name: 'Montserrat' },
  { alpha2: 'MT', name: 'Malta' },
  { alpha2: 'MU', name: 'Mauritius' },
  { alpha2: 'MV', name: 'Maldives' },
  { alpha2: 'MW', name: 'Malawi' },
  { alpha2: 'MX', name: 'Mexico' },
  { alpha2: 'MY', name: 'Malaysia' },
  { alpha2: 'MZ', name: 'Mozambique' },
  { alpha2: 'NA', name: 'Namibia' },
  { alpha2: 'NC', name: 'New Caledonia' },
  { alpha2: 'NE', name: 'Niger' },
  { alpha2: 'NF', name: 'Norfolk Island' },
  { alpha2: 'NG', name: 'Nigeria' },
  { alpha2: 'NI', name: 'Nicaragua' },
  { alpha2: 'NL', name: 'Netherlands' },
  { alpha2: 'NO', name: 'Norway' },
  { alpha2: 'NP', name: 'Nepal' },
  { alpha2: 'NR', name: 'Nauru' },
  { alpha2: 'NU', name: 'Niue' },
  { alpha2: 'NZ', name: 'New Zealand' },
  { alpha2: 'OM', name: 'Oman' },
  { alpha2: 'PA', name: 'Panama' },
  { alpha2: 'PE', name: 'Peru' },
  { alpha2: 'PF', name: 'French Polynesia' },
  { alpha2: 'PG', name: 'Papua New Guinea' },
  { alpha2: 'PH', name: 'Philippines' },
  { alpha2: 'PK', name: 'Pakistan' },
  { alpha2: 'PL', name: 'Poland' },
  { alpha2: 'PM', name: 'Saint Pierre and Miquelon' },
  { alpha2: 'PN', name: 'Pitcairn' },
  { alpha2: 'PR', name: 'Puerto Rico' },
  { alpha2: 'PS', name: 'Palestine, State of' },
  { alpha2: 'PT', name: 'Portugal' },
  { alpha2: 'PW', name: 'Palau' },
  { alpha2: 'PY', name: 'Paraguay' },
  { alpha2: 'QA', name: 'Qatar' },
  { alpha2: 'RE', name: 'Réunion' },
  { alpha2: 'RO', name: 'Romania' },
  { alpha2: 'RS', name: 'Serbia' },
  { alpha2: 'RU', name: 'Russian Federation' },
  { alpha2: 'RW', name: 'Rwanda' },
  { alpha2: 'SA', name: 'Saudi Arabia' },
  { alpha2: 'SB', name: 'Solomon Islands' },
  { alpha2: 'SC', name: 'Seychelles' },
  { alpha2: 'SD', name: 'Sudan' },
  { alpha2: 'SE', name: 'Sweden' },
  { alpha2: 'SG', name: 'Singapore' },
  { alpha2: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
  { alpha2: 'SI', name: 'Slovenia' },
  { alpha2: 'SJ', name: 'Svalbard and Jan Mayen' },
  { alpha2: 'SK', name: 'Slovakia' },
  { alpha2: 'SL', name: 'Sierra Leone' },
  { alpha2: 'SM', name: 'San Marino' },
  { alpha2: 'SN', name: 'Senegal' },
  { alpha2: 'SO', name: 'Somalia' },
  { alpha2: 'SR', name: 'Suriname' },
  { alpha2: 'SS', name: 'South Sudan' },
  { alpha2: 'ST', name: 'Sao Tome and Principe' },
  { alpha2: 'SV', name: 'El Salvador' },
  { alpha2: 'SX', name: 'Sint Maarten (Dutch part)' },
  { alpha2: 'SY', name: 'Syrian Arab Republic' },
  { alpha2: 'SZ', name: 'Eswatini' },
  { alpha2: 'TC', name: 'Turks and Caicos Islands' },
  { alpha2: 'TD', name: 'Chad' },
  { alpha2: 'TF', name: 'French Southern Territories' },
  { alpha2: 'TG', name: 'Togo' },
  { alpha2: 'TH', name: 'Thailand' },
  { alpha2: 'TJ', name: 'Tajikistan' },
  { alpha2: 'TK', name: 'Tokelau' },
  { alpha2: 'TL', name: 'Timor-Leste' },
  { alpha2: 'TM', name: 'Turkmenistan' },
  { alpha2: 'TN', name: 'Tunisia' },
  { alpha2: 'TO', name: 'Tonga' },
  { alpha2: 'TR', name: 'Türkiye' },
  { alpha2: 'TT', name: 'Trinidad and Tobago' },
  { alpha2: 'TV', name: 'Tuvalu' },
  { alpha2: 'TW', name: 'Taiwan' },
  { alpha2: 'TZ', name: 'Tanzania' },
  { alpha2: 'UA', name: 'Ukraine' },
  { alpha2: 'UG', name: 'Uganda' },
  { alpha2: 'UM', name: 'United States Minor Outlying Islands' },
  { alpha2: 'US', name: 'United States' },
  { alpha2: 'UY', name: 'Uruguay' },
  { alpha2: 'UZ', name: 'Uzbekistan' },
  { alpha2: 'VA', name: 'Holy See' },
  { alpha2: 'VC', name: 'Saint Vincent and the Grenadines' },
  { alpha2: 'VE', name: 'Venezuela' },
  { alpha2: 'VG', name: 'Virgin Islands (British)' },
  { alpha2: 'VI', name: 'Virgin Islands (U.S.)' },
  { alpha2: 'VN', name: 'Viet Nam' },
  { alpha2: 'VU', name: 'Vanuatu' },
  { alpha2: 'WF', name: 'Wallis and Futuna' },
  { alpha2: 'WS', name: 'Samoa' },
  { alpha2: 'YE', name: 'Yemen' },
  { alpha2: 'YT', name: 'Mayotte' },
  { alpha2: 'ZA', name: 'South Africa' },
  { alpha2: 'ZM', name: 'Zambia' },
  { alpha2: 'ZW', name: 'Zimbabwe' },
];

/** Countries labs ship in, offered first in a picker. */
export const COMMON_COUNTRY_CODES: ReadonlyArray<string> = ['US', 'IL'];

export function countryName(alpha2: string | null | undefined): string | null {
  const code = (alpha2 ?? '').trim().toUpperCase();
  return COUNTRIES.find((country) => country.alpha2 === code)?.name ?? null;
}

/** US states, DC and territories, by USPS code — couriers route US parcels by these. */
export const US_STATES: ReadonlyArray<{ code: string; name: string }> = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'GU', name: 'Guam' },
  { code: 'VI', name: 'U.S. Virgin Islands' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'MP', name: 'Northern Mariana Islands' },
];
